import React, {useEffect, useMemo, useState} from 'react';
import styles from "./RaffleParticipantsList.module.scss";
import {DataGrid} from "@mui/x-data-grid";
import moment from "moment";
import Papa from "papaparse";
import {saveAs} from "file-saver";
import Button, {BUTTON_TYPE_SECONDARY} from "../../Components/Button/Button";

const TasksColums = [
    {field: 'solanaWallet', headerName: 'Wallet', flex: 2},
    {field: 'username', headerName: 'Username', flex: 1},
    {
        field: 'profileImage',
        headerName: 'Profile Image',
        width: 100,
        renderCell: (params) => (
            params.value ? <img className={styles.rankImage} src={params.value} alt="profileImage"/> : ''
        )
    },
    {field: 'totalTicketsPurchased', headerName: 'Total Tickets Purchased', width: 200},
    {field: 'numberOfTransactions', headerName: 'Number of Transactions', width: 200},
    {field: 'lastTransactionTime', headerName: 'Last Transaction Time', width: 250},
];

const RaffleParticipantsList = (props) => {
    const {
        raffle
    } = props;

    const participants = raffle?.allParticipation;

    const [selectedData, setSelectedData] = useState();

    const formatedRows = useMemo(() => {
        if (!participants) return [];

        return participants.map(row => {


          return {
              id: row.solanaWallet,
              solanaWallet: row.solanaWallet,
              username: row.username,
              profileImage: row.profileImage,
              totalTicketsPurchased: row.purchasedTickets,
              numberOfTransactions: row.transactions.length,
              lastTransactionTime: moment.unix(row.transactions[0].timestamp / 1000).format('YYYY-MM-DD , h:mm A'),
          }
        })
    }, [participants]);

    const downloadCSV = async () => {
        const csv = Papa.unparse(formatedRows);
        const filename = `Raffle_${raffle.name}_Participants_${moment().format('YYYY-MM-DD')}.csv`;
        const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
        saveAs(blob, filename);
    }


  return (
      <div className={styles.missionParticipantsContainer}>
          <Button
              buttonType={BUTTON_TYPE_SECONDARY}
              text="CSV Export"
              onClick={downloadCSV}
              disabled={!raffle || !raffle?.allParticipation || raffle?.allParticipation.length === 0}/>
          <div className={styles.tableContainer}>
              {formatedRows &&
                  <DataGrid
                      rows={formatedRows}
                      onCellDoubleClick={(params) => setSelectedData(params.row)}
                      columns={TasksColums}
                  />}
          </div>
      </div>
  )
}



export default RaffleParticipantsList;
